import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import MobileLandscapeDashboardShell, { useStageFit } from './mobile-landscape-dashboard-shell';

// 手机横屏(844×390)答题页外壳:复用 dashboard-shell 舞台,主区挂父级传入的 QuizCarousel(可滚动)

export function useMobileLandscape() {
  const [is, setIs] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(max-height: 500px)').matches,
  );
  useEffect(() => {
    const mq = window.matchMedia('(max-height: 500px)');
    const on = () => setIs(mq.matches);
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, []);
  return is;
}

export default function MobileLandscapeAnswer({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  const isMobileLandscape = useMobileLandscape();
  // 宽屏铺满:取与舞台壳一致的 shift(见 useStageFit)。答题面板吃掉 shift 变宽(内部 QuizCarousel 随容器铺满)。须在下方 early return 之前调用以守 hooks 规则。
  const { shift } = useStageFit();
  if (!isMobileLandscape) return null;

  const content = (
    <>
      {/* 标题:与练习/总览 h1 同坐标/规格(Figma title fs20 fw520) */}
      <h1
        style={{
          position: 'absolute', left: 205, top: 68, margin: 0,
          fontSize: 20, fontWeight: 520, color: '#000',
          fontFamily: 'var(--font-sans)', lineHeight: '20px',
        }}
      >
        {title}
      </h1>
      {/* 答题面板(Figma Rectangle 46):内部可滚动,挂同一个 QuizCarousel */}
      <div
        className="ml-thin-scroll"
        style={{
          position: 'absolute', left: 206, top: 101, width: 627 + shift, height: 277,
          borderRadius: 21, background: '#F3F3F4',
          overflowY: 'auto', overflowX: 'hidden', padding: '13px 17px',
        }}
      >
        {children}
      </div>
    </>
  );

  return createPortal(
    <div
      className="hidden [@media(max-height:500px)]:flex fixed inset-0 items-center justify-center overflow-hidden"
      style={{ background: 'var(--practice-page-bg)' }}
    >
      <MobileLandscapeDashboardShell>{content}</MobileLandscapeDashboardShell>
    </div>,
    document.body,
  );
}
